module.exports = __webpack_public_path__ + "img/strip_b.84497dc7.jpg";